import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'a[sdLink], button[sdLink]',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SdvorLinkComponent {
  /**
   * Добавить подчеркивание
   */
  @Input() underlined = false;

  /**
   * В неактивном состоянии
   */
  @HostBinding('attr.disabled')
  @Input()
  disabled: boolean = null;

  @HostBinding('class')
  get classes(): Record<string, boolean> {
    return {
      link: true,
      'state-disabled': this.disabled,
      underlined: this.underlined,
    };
  }
}
